import { Component, OnInit, inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { ILoaderData } from './loader-data';

@Component({
  selector: 'howden-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
  imports: [MatProgressSpinner]
})
export class LoaderComponent implements OnInit {
  private readonly data = inject<ILoaderData>(MAT_DIALOG_DATA);

  msg = '';

  ngOnInit(): void {
    this.msg = !this.data ? '' : this.data.msg;
  }
}
